import {Component} from '@angular/core';

@Component({
  selector: 'app-distance-calculation-help',
  standalone: true,
  imports: [],
  templateUrl: './distance-calculation-help.component.html',
  styleUrl: './distance-calculation-help.component.scss'
})
export class DistanceCalculationHelpComponent {

}
